import { useCallback } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { useTranslation } from 'react-i18next';
import './style.scoped.css';
import Button, { ButtonTypes } from 'src/components/Button';
import chrevronRight from 'src/assets/chevron_right_blue.svg';
import { Link } from 'react-router-dom';
import { sendOpenNewWebview } from 'src/utils';
import HomeItem from 'src/models/HomeItem';

export interface HomeSliderInterface {
  title?: string;
  viewAllPath?: string;
  type?: string;
  data?: HomeItem;
}

const HomeSlider = (props) => {
  const { data, title, type = 'itemStory', viewAllPath } = props;
  const { t } = useTranslation();

  const _handlePressItem = useCallback((item) => {
    sendOpenNewWebview(item);
  }, []);

  const _renderItem = (item, index) => {
    if (type == 'itemStory') {
      return (
        <div
          className="itemStory"
          key={item.id}
          style={{ backgroundImage: `url(${item.photo})` }}
          onClick={() => _handlePressItem(item)}
        ></div>
      );
    } else if (type == 'itemSlider') {
      return (
        <div
          className="itemSlider"
          key={item.id}
          onClick={() => _handlePressItem(item)}
        >
          <img src={item.photo} className="itemSliderImage" />
        </div>
      );
    }
  };

  return (
    <div>
      <div className="mb-5 flex flex-row">
        <div className="blockTitle3 flex flex-1 text-onSurface">{title}</div>
      </div>
      <div className="scrollContainer flex flex-row mb-5">
        {data.map(_renderItem)}
      </div>
      <div>
        <Link to={viewAllPath}>
          <Button
            text={t('view_more')}
            buttonType={ButtonTypes.primaryBorderless2}
            extraClassName="w-full"
            rightIcon={<img src={chrevronRight} className="w-6 h-6 ml-2" />}
          />
        </Link>
      </div>
    </div>
  );
};

export default HomeSlider;
